<template>
  <div class="package mb-0 d-flex align-items-center">
    <Select :options="receiveOptions" :value="object.package" @changeValue="changeReceiveValue" placeholder="Package" />
    <component :is="subReceivePackage" :config="subReceiveConfig" @changeValue="changeSubReceiveValue" />
    <input type="text" :value="object.range" @change="changeReceiveRange" class="form-control" placeholder="Range" style="width: 200px" />
  </div>
</template>

<script>
import DefaultValue from './../DefaultValue.vue'
export default {
  extends: DefaultValue,
  components: {},
  computed: {
    receivePackages() {
      return this.more?.events?.[this.event]?.packages || []
    },
    receiveOptions() {
      return (
        this.receivePackages.reduce((result, current) => {
          result.push({
            id: current,
            text: this.more?.receive_packages?.[current]?.label
          })
          return result
        }, []) || []
      )
    },
    subReceivePackage() {
      let packageName
      if (Object.keys(this.more?.receive_packages).includes(this.object?.package)) {
        packageName = _.pascalCase(this.object.package)
      }
      return packageName ? `SubReceive${packageName}` : null
    },
    subReceiveConfig() {
      let config = _.cloneDeep(this.config)
      config.parentPackage = this.object.package
      config.value = _.cloneDeep(this.object)
      return config
    }
  },
  methods: {
    registerComponent({ name, type, path }) {
      path = `/views/Automation/Modal/${path}`
      if (!this.$options.components?.[`${type}${name}`]) {
        this.$options.components[`${type}${name}`] = this.$util.requireOrNull(`${path}/${name}Package.vue`) || this.$util.requireOrNull(`${path}/DefaultPackage.vue`)
      }
      return this.$options.components[`${type}${name}`]
    },
    changeReceiveValue(value) {
      this.$emit('changeValue', {
        field: 'package',
        value
      })
    },
    changeSubReceiveValue({ field, value }) {
      this.$emit('changeValue', {
        field,
        value
      })
    },
    changeReceiveRange(e) {
      this.$emit('changeValue', {
        field: 'range',
        value: e.target.value
      })
    }
  },
  watch: {
    receivePackages: {
      handler(values) {
        values.forEach((name) => {
          name = _.pascalCase(name)
          this.registerComponent({
            name,
            type: 'Receive',
            path: 'Conditions/Packages'
          })
        })
      },
      immediate: true
    },
    subReceivePackage: {
      handler(name) {
        if (!name) return
        this.registerComponent({
          name: name ? name.replace(/SubReceive/g, '') : null,
          type: 'SubReceive',
          path: 'Conditions/Packages'
        })
      },
      immediate: true
    }
  },
  props: {
    object: Object,
    config: Object
  }
}
</script>
